import { useLang } from "../i18n";
import { fmtNum } from "../api";

const fmtPl = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${Math.round(v).toLocaleString()}`);

export const SignalsOpsTable = ({ signals }) => {
  const { t } = useLang();
  return (
    <div className="border border-white/10 bg-[#111111] overflow-x-auto max-h-[540px] overflow-y-auto">
      <table className="w-full text-xs font-mono">
        <thead className="sticky top-0 bg-[#1A1A1A]">
          <tr className="text-slate-500 uppercase tracking-wider text-[10px]">
            <th className="text-left px-4 py-2">{t("date")}</th>
            <th className="text-left px-2 py-2">{t("col_signal")}</th>
            <th className="text-left px-2 py-2">{t("col_instruction")}</th>
            <th className="text-right px-2 py-2">{t("col_entry")}</th>
            <th className="text-right px-2 py-2">{t("score")}</th>
            <th className="text-right px-2 py-2">{t("col_pl")}</th>
            <th className="text-right px-4 py-2">{t("col_year_balance")}</th>
          </tr>
        </thead>
        <tbody>
          {signals.map((s) => (
            <tr key={s.id} data-testid={`signal-ops-row-${s.id}`} className="border-t border-white/5 hover:bg-white/[0.03]">
              <td className="px-4 py-2 text-slate-400">{s.date}</td>
              <td className={`px-2 py-2 font-bold ${s.direction === "LONG" ? "text-emerald-400" : "text-red-400"}`}>{s.direction}</td>
              <td className="px-2 py-2 text-slate-300">{s.instruction ? s.instruction.replace("_SR", " S&R") : "—"}</td>
              <td className="px-2 py-2 text-right text-slate-300">{s.entry_price != null ? fmtNum(s.entry_price) : "—"}</td>
              <td className="px-2 py-2 text-right text-slate-500">{s.score > 0 ? "+" : ""}{s.score}</td>
              <td className={`px-2 py-2 text-right ${s.pl_eur >= 0 ? "text-emerald-400" : "text-red-400"}`}>
                {fmtPl(s.pl_eur)}{s.pl_open ? "*" : ""}
              </td>
              <td className={`px-4 py-2 text-right ${s.year_balance >= 0 ? "text-emerald-400" : "text-red-400"}`}>
                {fmtPl(s.year_balance)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
